import React, { createContext, useContext, useEffect, useState } from 'react';

import {getCompanyPermissions, getUserPermissions} from "./permissionService";
// Permission checks accept any backend enum string. Use UserPermission / CompanyPermission from permissionCodes.js (re-exported in utils.js) for dot access without maintaining lists.
import {getAuthToken} from "../utils/auth";

const PermissionContext = createContext();

export const PermissionProvider = ({ children, refreshInterval = 5 * 60 * 1000 }) => {
    const [companyPermissions, setCompanyPermissions] = useState([]);
    const [userPermissions, setUserPermissions] = useState([]);
    const [loadingPermissions, setLoadingPermissions] = useState(true);
    const [authToken, setAuthTokenState] = useState(() => getAuthToken());

    const fetchPermissions = async () => {
        if (!getAuthToken()) {
            setUserPermissions([]);
            setCompanyPermissions([]);
            setLoadingPermissions(false);
            return;
        }

        try {
            const userPerms = await getUserPermissions();
            setUserPermissions(userPerms);
            const companyPerms = await getCompanyPermissions();
            setCompanyPermissions(companyPerms);
        } catch (error) {
            console.error('Erro ao buscar permissões:', error);
            setUserPermissions([]);
            setCompanyPermissions([]);
        } finally {
            setLoadingPermissions(false);
        }
    };

    useEffect(() => {
        const currentToken = getAuthToken();
        setAuthTokenState(currentToken);

        if (currentToken) {
            fetchPermissions();

            const interval = setInterval(() => {
                fetchPermissions();
            }, refreshInterval);

            return () => clearInterval(interval);
        } else {
            setLoadingPermissions(false);
        }
    }, [authToken, refreshInterval]);

    const hasUserPermission = (permission) => {
        return userPermissions.includes(permission);
    };
    
    const hasCompanyPermission = (permission) => {
        return companyPermissions.includes(permission);
    };

    return (
        <PermissionContext.Provider value={{ userPermissions, companyPermissions, hasUserPermission, hasCompanyPermission, loadingPermissions }}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermission = () => useContext(PermissionContext);
